import React from 'react'
import { Grid, Icon, Segment, SemanticICONS } from 'semantic-ui-react'

interface DetailSegmentProps {
  title: string
  main_icon: SemanticICONS
  additional_icon?: SemanticICONS
  value: number
}

export const DetailSegment: React.FC<DetailSegmentProps> = props => {
  return (
    <Segment className='segment-dashboard' color='red' textAlign='center'>
      <h1>{props.title}</h1>
      <br />
      <Grid columns='equal'>
        <Grid.Row className='row-dashboard'>
          <Grid.Column>
            <Icon name={props.additional_icon} size='big' />
            <Icon name={props.main_icon} size='huge' />
          </Grid.Column>
          <Grid.Column className='segment-number'>
            <br />
            <div>{props.value}</div>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
  )
}
